import { atom } from "jotai";
import { authTokenAtom } from "./auth";
import { userPreferencesAtom } from "./user-preferences";
import { fetchQuotaUsage, type QuotaUsageModel } from "shared/requests/quota";

export const quotaUsageAtom = atom<QuotaUsageModel | null>(null);

export const fetchQuotaUsageAtom = atom(null, async (get, set) => {
  const token = get(authTokenAtom);
  const userId = get(userPreferencesAtom)._id;

  if (!token || !userId) {
    set(quotaUsageAtom, null);
    return;
  }

  try {
    const res = await fetchQuotaUsage(token, userId);
    set(quotaUsageAtom, res);
  } catch {
    set(quotaUsageAtom, null);
  }
});
